import { useState } from "react";
import { PageTabs } from "@/components/ui/page-tabs";

import { EmailTemplatesList } from "./components/EmailTemplatesList";
import DocumentTemplatesList from "./components/DocumentTemplatesList";

type TemplateTabType = "documentos" | "correos";
const templateTabs = [
  {
    label: "Documentos",
    key: "documentos",
  },
  {
    label: "Correos",
    key: "correos",
  },
];

const TemplatesPage = () => {
  const [selectedTab, setSelectedTab] = useState<TemplateTabType>("documentos");

  return (
    <>
      <PageTabs
        className="mx-2"
        activeKey={selectedTab}
        onTabChange={(tab) => setSelectedTab(tab as TemplateTabType)}
        tabs={templateTabs}
      />
      {selectedTab === "documentos" ? (
        <DocumentTemplatesList />
      ) : (
        <EmailTemplatesList />
      )}
    </>
  );
};

export default TemplatesPage;
